<div class="row">
    <div class="col-12" style="margin-top: 100px;"></div>
</div>
<div class="container mb-5">
    <div class="row no-gutters justify-content-center">
        <div class="col-md-12">
            <div class="card mt-5" *ngFor="let developer of developerData">
                <div class="row g-0">
                    <div class="col-md-4 cursor" (click)="redirectProperty(developer.developer_id)">
                        <div class="image-wrapper">
                            <img [src]="shared.getImageURL(developer.developer_logo)"  class="img-fluid">
                        </div>
                    </div>
                    <div class="col-md-8 cursor" (click)="redirectProperty(developer.developer_id)">
                        <div class="card-body height-100">
                            <div class="d-flex flex-column height-100">
                                <h5 class="fs-16 fw-bolder" *ngIf="developer.developer_name">
                                    {{ developer.developer_name }}
                                </h5>
                                <p class="card-text truncated-text" *ngIf="developer.developer_description">
                                    {{ developer.developer_description }}
                                </p>
                                <div class="col-12">
                                <button class="btn btn-theme" (click)="redirectProperty(developer.developer_id)">View Properties</button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>